<template>
    <div id="portfolioMainForm">
        <div class="form-row">
            <div class="form-group col-md-6 d-flex justify-content-center input-group">
                <div class="e-card pointer" v-on:click="toClients()">
                    <div class="e-card-header">
                        <div class="e-card-header-caption" style="color: #75477e; text-align: center; text-transform: uppercase;">
                            <h4>My Clients</h4>
                        </div>
                    </div>
                    <div class="e-card-header">
                        <div class="e-card-header-caption" style="color: #a0619c; text-align: center; ">
                            <h4>{{ clients.length }}</h4>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group col-md-6 d-flex justify-content-center input-group">
                <div class="e-card pointer" v-on:click="toTrades()">
                    <div class="e-card-header">
                        <div class="e-card-header-caption" style="color: #3477be; text-align: center; text-transform: uppercase;">
                            <h4>My Trades</h4>
                        </div>
                    </div>
                    <div class="e-card-header">
                        <div class="e-card-header-caption" style="color: #90a9d2; text-align: center; ">
                            <h4>{{ trades.length }}</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-md-6 d-flex justify-content-center input-group">
                <div class="e-card">
                    <div class="e-card-header">
                        <div class="e-card-header-caption" style="color: #cb5719; text-align: center; text-transform: uppercase;">
                            <h4>My Triggers</h4>
                        </div>
                    </div>
                    <div class="e-card-header">
                        <div class="e-card-header-caption" style="color: #fbba12; text-align: center; ">
                            <h4>{{ totalTriggers }}</h4>
                        </div>
                    </div>
                    <div class="form-row" style="padding-top:16px;">
                        <div class="col-md-6">
                            <div v-on:click="toLiveTriggers()" class="form-row justify-content-center pointer">
                                <div class="col-md-5">
                                    <h6>Active Triggers</h6>
                                </div>
                                <div class="col-md-2" style="color: #fbba12;">
                                    <h6>{{ activeTriggers }}</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-row" style="padding-top:16px;">
                        <div class="col-md-6">
                            <div v-on:click="toDueLiveTriggers()" class="form-row justify-content-center pointer">
                                <div class="col-md-5">
                                    <h6>Due Live Triggers</h6>
                                </div>
                                <div class="col-md-2" style="color: #fbba12;">
                                    <h6>{{ dueLiveTriggers }}</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-row" style="padding-top:16px;">
                        <div class="col-md-6">
                            <div v-on:click="toExpiredTriggers()" class="form-row justify-content-center pointer">
                                <div class="col-md-5">
                                    <h6>Expired Triggers</h6>
                                </div>
                                <div class="col-md-2" style="color: #fbba12;">
                                    <h6>{{ expiredTriggers }}</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group col-md-6 d-flex justify-content-center input-group">
                <div class="e-card">
                    <div class="e-card-header">
                        <div class="e-card-header-caption" style="color: red; text-align: center; text-transform: uppercase;">
                            <h4>My Alerts</h4>
                        </div>
                    </div>
                    <div class="e-card-header">
                        <div class="e-card-header-caption" style="color: #b9581b; text-align: center; ">
                            <h4>{{ totalAlerts }}</h4>
                        </div>
                    </div>
                    <div class="form-row" style="padding-top:16px;">
                        <div class="col-md-6">
                            <div v-on:click="toTriggerHitAlerts()" class="form-row justify-content-center pointer">
                                <div class="col-md-5">
                                    <h6>Hit Triggers</h6>
                                </div>
                                <div class="col-md-2" style="color: #b9581b;">
                                    <h6>{{ hitTriggerAlerts }}</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-row" style="padding-top:16px;">
                        <div class="col-md-6">
                            <div v-on:click="toStatusAlerts()" class="form-row justify-content-center pointer">
                                <div class="col-md-5">
                                    <h6>Trigger Status</h6>
                                </div>
                                <div class="col-md-2" style="color: #b9581b;">
                                    <h6>{{ triggerStatusAlerts }}</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-row" style="padding-top:16px;">
                        <div class="col-md-6">
                            <div v-on:click="toDeadlineAlerts()" class="form-row justify-content-center pointer">
                                <div class="col-md-5">
                                    <h6>Default Deadlines</h6>
                                </div>
                                <div class="col-md-2" style="color: #b9581b;">
                                    <h6>{{ defaultDeadlineAlerts }}</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import { TextBoxPlugin } from "@syncfusion/ej2-vue-inputs";
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import apis from '@/common/network';
    import urls from '@/common/urls';

    Vue.use(TextBoxPlugin);
    Vue.use(DialogUtility);

    export default {
        name: 'PortfolioForm',
        data() {
            return {
                data: {},
                clients: [],
                trades: [],

                //my triggers
                totalTriggers: 0,
                activeTriggers: 0,
                dueLiveTriggers: 0,
                expiredTriggers: 0,

                // my alerts
                totalAlerts: 0,
                hitTriggerAlerts: 0,
                triggerStatusAlerts: 0,
                defaultDeadlineAlerts: 0
            }
        },
        methods: {
            fetchClientsData: function () {
                apis.protectedApi('utils/parentclients')
                    .then(response => {
                        this.clients = response.data;
                    }).catch(e => {
                        if (e.response.data.message) {
                            this.showErrorDialog(e.response.data.message);
                        }
                    });
            },
            fetchTradesData: function () {
                apis.protectedApi('utils/userTrades')
                    .then(response => {
                        this.trades = response.data;
                    }).catch(e => {
                        if (e.response.data.message) {
                            this.showErrorDialog(e.response.data.message);
                        }
                    });
            },
            fetchTriggersData() {
                apis.protectedApi(`${urls.apiBaseUrl}ContractTrigger/GroupCounts`).then(gc => {
                    this.activeTriggers = gc.data.active;
                    this.dueLiveTriggers = gc.data.dueLive;
                    this.expiredTriggers = gc.data.expired;
                    this.totalTriggers = gc.data.active + gc.data.dueLive + gc.data.expired;
                }).catch(
                    response => { this.handleError(response); }
                );

            },
            fetchAlertsData(id) {
                apis.protectedApi(`${urls.apiBaseUrl}TriggerAlert/GroupCounts`).then(gc => {
                    this.hitTriggerAlerts = gc.data.hit;
                    this.triggerStatusAlerts = gc.data.status;
                    this.defaultDeadlineAlerts = gc.data.deadline;
                    this.totalAlerts = gc.data.hit + gc.data.status + gc.data.deadline;
                }
                ).catch(
                    response => { this.handleError(response); }
                );
            },
            handleError(error) {
                var message = error.response.data.message != undefined ? error.response.data.message : "Error invoking service, please contact support";
                DialogUtility.alert({
                    title: 'Error',
                    content: message,
                    position: { X: 0, Y: 200 },
                    showCloseIcon: true,
                    closeOnEscape: true,
                    animationSettings: { effect: 'Zoom' },
                    zIndex: 1100
                });
            },
            toClients(args) {
                this.$router.push({ name: 'MyClients' });
            },
            toTrades(args) {
                this.$router.push({ name: 'Trades' });
            },
            toLiveTriggers(args) {
                this.$router.push({ name: 'LiveTrigger' });
            },
            toDueLiveTriggers(args) {
                this.$router.push({ name: 'DueLiveTrigger' });
            },
            toExpiredTriggers(args) {
                this.$router.push({ name: 'ExpiredTrigger' });
            },
            toTriggerHitAlerts(args) {
                this.$router.push({ name: 'Hit Triggers' });
            },
            toStatusAlerts(args) {
                this.$router.push({ name: 'Trigger Status' });
            },
            toDeadlineAlerts(args) {
                this.$router.push({ name: 'Default Deadlines' });
            },
            populateTriggers: function () {
                apis.protectedApi('utils/userTriggers')
                    .then(response => {
                        this.triggers = response.data;
                    }).catch(e => {
                        if (e.response.data.message) {
                            this.showErrorDialog(e.response.data.message);
                        }
                    });
            }
        },
        created: function () {
            this.fetchClientsData();
            this.fetchTradesData();
            this.fetchTriggersData();
            this.fetchAlertsData();
        },
    }
</script>

<style scoped>
    .pointer {
        cursor: pointer;
    }
</style>